/**
 * Resource that represents a Print Session (a job).
 *
 * @name PrintSession
 * @class
 * @augments TmrResource
 */
function PrintSessionFactory(TmrResource, Printer, User, TmrApi) {
  'ngInject'
  let actions = {
    cancel: {
      method: 'POST',
      url: TmrApi.endpoint('PrintSession.cancel'),
    },
    bulkCancel: {
      method: 'POST',
      url: TmrApi.endpoint('PrintSession.bulkCancel'),
      isArray: true,
    },
  }
  let referencedProperties = [
    // printSession.printer property will be instantiated as a Printer resource
    { property: 'printer', resource: Printer },
    // printSession.creationUser property will be instantiated as a User resource
    { property: 'creationUser', resource: User },
  ]
  let PrintSession = TmrResource('PrintSession', actions, referencedProperties)
  return PrintSession
}

export const factory = ['PrintSession', PrintSessionFactory]
